import React, { FC, JSX, useEffect } from 'react';
import { useAuthContext } from '@app/utils/auth-provider';
import { Navigate } from 'react-router-dom';
import { navigationRoutes } from '@app/utils/navigation-routes';
import { useGetKerberosAuthApiStatusQuery } from '@app/store/api/kerberos-auth.api';
import { Loading } from '@ui';

const RequiredAuth: FC<{ children: JSX.Element }> = (props) => {
  const { isLoading, data, isSuccess } = useGetKerberosAuthApiStatusQuery();

  useEffect(() => {
    if (!isSuccess) return;
    if (!data) return;
    const result = data.sso_krb_enabled;
    const currentData = localStorage.getItem('sso_krb_enabled');
    if (String(result) === currentData) return;
    localStorage.setItem('sso_krb_enabled', String(data.sso_krb_enabled));
  }, [data, isSuccess]);

  const sso_krb_enabled = data?.sso_krb_enabled || false;
  const { children } = props;

  const { isAuth } = useAuthContext();
  if (isLoading) return <Loading />;
  if (!isAuth && !sso_krb_enabled)
    return <Navigate to={`/${navigationRoutes.authorization}`} replace />;
  return children;
};

export default RequiredAuth;
